import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ButtonNavigationComponent } from './components/button-navigation/button-navigation.component';
import { ButtonSetupFourComponent } from './components/button-navigation/button-setup-four/button-setup-four.component';
import { ButtonSetupOneComponent } from './components/button-navigation/button-setup-one/button-setup-one.component';
import { ButtonSetupTwoComponent } from './components/button-navigation/button-setup-two/button-setup-two.component';
import { ForcedChoiceDisplayComponent } from './components/forced-choice-display/forced-choice-display.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { QuestionComponent } from './components/questionnaire/question/question.component';
import { QuestionnaireComponent } from './components/questionnaire/questionnaire.component';
import { TestDisplayComponent } from './components/test-display/test-display.component';
import { TriggerChoiceDirective } from './directives/trigger-choice.directive';
import { TriggerForcedChoiceDirective } from './directives/trigger-forced-choice.directive';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { environment } from 'src/environments/environment';
import { AppMetaEffects } from 'src/state/app-meta/app-meta.effects';
import { ConfigEffects } from 'src/state/config/config.effects';
import { appReducer } from '../state/app.state';
import { ConjointDisplayComponent } from './components/conjoint-display/conjoint-display.component';
import { ConsentFormComponent } from './components/consent-form/consent-form.component';
import { ContinueButtonLightComponent } from './components/continue-button-light/continue-button-light.component';
import { ContinueButtonComponent } from './components/continue-button/continue-button.component';
import { CountdownTimerComponent } from './components/countdown-timer/countdown-timer.component';
import { DisplayComponent } from './components/display/display.component';
import { IATDisplayComponent } from './components/iat-display/iat-display.component';
import { ImageFullComponent } from './components/image-full/image-full.component';
import { InstructionContainerBgFullComponent } from './components/instruction-container-bg-full/instruction-container-bg-full.component';
import { InstructionContainerBgHalfComponent } from './components/instruction-container-bg-half/instruction-container-bg-half.component';
import { InstructionContainerBgMonoComponent } from './components/instruction-container-bg-mono/instruction-container-bg-mono.component';
import { InstructionContainerComponent } from './components/instruction-container/instruction-container.component';
import { InstructionsComponent } from './components/instructions/instructions.component';
import { IntermissionComponent } from './components/intermission/intermission.component';
import { MediaDisplayComponent } from './components/media-display/media-display.component';
import { OverviewBlockComponent } from './components/overview-block/overview-block.component';
import { OverviewComponent } from './components/overview/overview.component';
import { PrimingDisplayComponent } from './components/priming-display/priming-display.component';
/* import { DragNDropComponent } from './components/questionnaire/drag-n-drop/drag-n-drop.component'; */
import { VideoComponent } from './components/questionnaire/video/video.component';

import { DtComponent } from './components/dt/dt.component';
import { LikertComponent } from './components/questionnaire/likert/likert.component';
import { SliderComponent } from './components/questionnaire/slider/slider.component';
import { ScreeningComponent } from './components/screening/screening.component';
import { TerminateComponent } from './components/terminate/terminate.component';
import { SubscriptionInterceptor } from './interceptors/subscription.interceptor';

registerLocaleData(localeDe, 'de-DE', localeDeExtra);

@NgModule({
  declarations: [
    AppComponent,
    TestDisplayComponent,
    TriggerChoiceDirective,
    ButtonNavigationComponent,
    ButtonSetupTwoComponent,
    ButtonSetupOneComponent,
    ButtonSetupFourComponent,
    NavbarComponent,
    QuestionnaireComponent,
    QuestionComponent,
    ForcedChoiceDisplayComponent,
    TriggerForcedChoiceDirective,
    /* DragNDropComponent, */
    SliderComponent,
    InstructionsComponent,
    InstructionContainerBgFullComponent,
    InstructionContainerBgHalfComponent,
    InstructionContainerBgMonoComponent,
    ContinueButtonComponent,
    ContinueButtonLightComponent,
    ConsentFormComponent,
    DisplayComponent,
    OverviewComponent,
    OverviewBlockComponent,
    CountdownTimerComponent,
    InstructionContainerComponent,
    IntermissionComponent,
    ImageFullComponent,
    LikertComponent,
    MediaDisplayComponent,
    IATDisplayComponent,
    PrimingDisplayComponent,
    ConjointDisplayComponent,
    ScreeningComponent,
    TerminateComponent,
    VideoComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    PdfViewerModule,
    NgbModule,
    DtComponent,
    StoreModule.forRoot(appReducer),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
      connectInZone: true
    }),
    EffectsModule.forRoot([AppMetaEffects, ConfigEffects])
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: SubscriptionInterceptor, multi: true },
    {
      provide: LOCALE_ID,
      useValue: 'de-DE'
    },
    {
      provide: 'BASE_URL',
      useFactory: function getBaseUrl() {
        return document.getElementsByTagName('base')[0].attributes[0].value || '/';
      }
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {}
